import { createStyles } from '@mantine/core'

type StylesParams = {
  expandWidget: boolean
}

export default createStyles((theme, { expandWidget }: StylesParams) => {
  return {
    root: {
      [theme.fn.largerThan('sm')]: {
        ...(!expandWidget && {
          height: 'auto',
        }),
      },
    },
    header: {},
    action: {},
    starterBox: {},
    scrollBody: {},
  }
})
